import styled, { css } from 'styled-components'
import { ISubPage } from '../../prismicTypes'
import Typography from '../../styles/typography'
import { replaceDoubleHyphen } from '../../utils/helpers'
import Slice from '../Slice'
import PrismicRichText from '../PrismicRichText'

interface IProps {
  data: ISubPage.IData
}

const SubpageHero: React.FC<IProps> = ({ data: { title, label, description } }: IProps) => {
  return (
    <Slice gridStyle={SCGrid}>
      <SCContentColumn>
        <SCContent>
          <SCHeaderLabel>{label}</SCHeaderLabel>
          <SCTitle>{replaceDoubleHyphen(title)}</SCTitle>
          <PrismicRichText extraParagraphStyle={Typography.pBody} richText={description} />
        </SCContent>
      </SCContentColumn>
    </Slice>
  )
}

export default SubpageHero

const SCContentColumn = styled.div`
  ${({ theme: { breakpoints } }) => css`
    grid-column: 1 / -1;
    margin: 0;
    margin-top: 3rem;
    display: flex;
    align-items: center;

    @media screen and (min-width: ${breakpoints.tabletMin}) {
      margin: 0;
      grid-column: 1 / 7;
    }

    @media screen and (min-width: ${breakpoints.desktopMin}) {
      margin: 5.5rem 0 0;
      grid-column: 1 / 8;
    }
  `}
`

const SCGrid = css`
  ${({ theme: { breakpoints } }) => css`
    margin: 5rem 0 3rem;
    overflow: hidden;
    @media screen and (min-width: ${breakpoints.tabletMin}) {
      margin-bottom: 5rem;
    }
    @media screen and (min-width: ${breakpoints.desktopMin}) {
      overflow: visible;
    }
  `}
`

const SCHeaderLabel = styled.span`
  ${Typography.eyebrow}
`

const SCTitle = styled.h1`
  ${({ theme: { breakpoints } }) => css`
    ${Typography.h1}
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    @media screen and (min-width: ${breakpoints.tabletMin}) {
      margin-bottom: 1.5rem;
    }
  `}
`

const SCContent = styled.div`
  display: flex;
  flex-direction: column;
`
